/**
 * report-builder-api
 * API сервиса генерации отчетов
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Тип источника данных: jdbc - запрос к БД | api - вызов через http | local - данные формируются на UI
 */
export type SourceType = 'api' | 'jdbc' | 'local';

export const SourceType = {
    Api: 'api' as SourceType,
    Jdbc: 'jdbc' as SourceType,
    Local: 'local' as SourceType
};

